import React from 'react';

import {Button, IconButton, Text} from '@albert-io/atomic';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function StudentHomepageHeader() {
  const {setShowJoinClassModal} = useStudentDashboard();

  return (
    <div className='col-span-full flex items-center px-x3 pt-x3'>
      <IconButton className='mr-x1' icon='bars' label='Toggle sidebar button' />
      <Text className='mr-x2 flex-1 font-black' size='xl'>
        Home
      </Text>
      <Button onClick={() => setShowJoinClassModal(true)} roundness='pill'>
        Join Class
      </Button>
    </div>
  );
}
